import { render, staticRenderFns } from "./checkDL.vue?vue&type=template&id=484623fa&scoped=true&"
import script from "./checkDL.vue?vue&type=script&lang=js&"
export * from "./checkDL.vue?vue&type=script&lang=js&"
import style0 from "./checkDL.vue?vue&type=style&index=0&id=484623fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484623fa",
  null
  
)

export default component.exports